fx.ns("models", class Mask extends fx.Model {

	constructor(data)
	{
        super(data);
    }
    
});
		